import { createFileRoute } from "@tanstack/react-router"
import { BlogPostList, BlogShell } from "@/components/blog-page"
import { publicPageHead } from "@/lib/seo"

export const Route = createFileRoute("/blog/")({
  head: () =>
    publicPageHead({
      path: "/blog",
      title: "Video to Shorts Guides: Clipping & Captions | intoshort Blog",
      description:
        "Learn how to turn long videos into shorts, clip YouTube videos and Twitch VODs, add captions, and reframe gameplay with facecam.",
    }),
  component: BlogIndex,
})

function BlogIndex() {
  return (
    <BlogShell>
      <header className="blog-hero">
        <p className="text-muted-foreground">The intoshort blog</p>
        <h1>Turn long videos into shorts worth sharing.</h1>
        <p className="blog-lead">
          Learn how to make shorts from existing videos, choose the moments,
          correct captions and get the vertical framing right. Start with a
          YouTube video, a Twitch VOD or your own recording.
        </p>
      </header>
      <BlogPostList />
    </BlogShell>
  )
}
